import React, { useEffect, useState, useRef } from 'react';
import { Route, Switch, Redirect } from 'react-router';
import { useLocation, useHistory } from "react-router-dom";
import * as R from "ramda";
import { useDispatch, useSelector } from 'react-redux';

import { DossiersMain } from './main';
import { fetchAllPartners, fetchUsersByRole } from '../../actions/backoffice/dossiers';
import { GetPartners, GetPartnersDefaultState } from '../../actions/backoffice/partners';
import { DossiersDetail } from './detail';
import { LoadingState } from '../../_common/loadingState';
import * as Loadings from '../../constants/loadings/backoffice/dossiers';


export const Dossiers = ({ dossierState }) => {
	const dispatch = useDispatch();
	const history = useHistory();
	const searchQuery = useLocation();
	const partnersReducer = useSelector(state => state.partnersReducer);
	const pageQuery = new URLSearchParams(searchQuery.search);

	let page = pageQuery.get('page');
	let search = pageQuery.get('search');
	let type = pageQuery.get('type');
	let partner = pageQuery.get('partner');
	let sortBy = pageQuery.get('sortBy');
	let sortDesc = pageQuery.get('sortDesc');

	partner = R.isNil(partner) ? '' : partner;
	page = R.isNil(page) ? 1 : parseInt(page);
	search = R.isNil(search) ? '' : search;
	type = R.isNil(type) ? '' : type;
	sortBy = R.isNil(sortBy) ? "creationDate" : sortBy;
	sortDesc = R.isNil(sortDesc) ? "true" : sortDesc;

	const [pageSearch, setPageSearch] = useState(search);
	const renderRef = useRef(false);


	useEffect(() => {
		if (R.isNil(partnersReducer.defaultPartners)) {
			dispatch(GetPartnersDefaultState());
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		if (isNaN(page) || page === 0) {
			history.push("/backoffice/dossiers");
			return;
		}

		dispatch(fetchUsersByRole("user", page, search, partner, type, sortBy, sortDesc));

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [searchQuery.search, history.location]);


	let timer = null;
	useEffect(() => {

		if (!renderRef.current) {
			renderRef.current = true;
			return;
		};

		if (R.isEmpty(pageSearch)) {
			history.push(`/backoffice/dossiers?page=${1}${type !== "" ? "&type=" + type : ""}${partner !== "" ? "&partner=" + partner : ""}${sortBy !== "" ? "&sortBy=" + sortBy : ""}${sortDesc === "" ? "" : sortDesc === "false" ? "&sortDesc=false" : "&sortDesc=true"}`);
			return;
		}

		clearTimeout(timer);
		timer = setTimeout(() => {
			dispatch(fetchUsersByRole("user", page, pageSearch, partner, type, sortBy, sortDesc));
		}, 1000);

		return () => clearTimeout(timer);

		// eslint-disable-next-line
	}, [pageSearch]);



	if (dossierState.isLoading.includes(Loadings.FETCHING_USERS_DOSSIERS) && R.isNil(dossierState.dossiers)) {
		return <LoadingState />;
	}

	if (R.isNil(dossierState.dossiers)) {
		return '';
	}

	const routerQuery = {
		page,
		search,
		type,
		sortBy,
		sortDesc,
		partner,
	};

	return (
		<Switch>
			<Route exact path="/backoffice/dossiers">
				<DossiersMain dossierState={dossierState} pageSearch={pageSearch} setPageSearch={setPageSearch} partnerState={partnersReducer} partners={partnersReducer.defaultPartners} routerQuery={routerQuery} />
			</Route>
			<Route path="/backoffice/dossiers/:user" >
				<DossiersDetail dossierState={dossierState} />
			</Route>
			<Route render={() => {
				return <Redirect exact to="/backoffice/dossiers" />;
			}} />
		</Switch>
	);

};


